import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeProviderComponent } from './theme-provider.component';

@NgModule({
  declarations: [ThemeProviderComponent],
  imports: [CommonModule],
  exports: [ThemeProviderComponent],
})
export class ThemeProviderModule {}
